<template>
  <div id="mainContainerMonetise" ref="mainContainerMonetise">
    <!-- {{ width }} -->
    <div v-if="!isLoaded">
      <div class="monetise-spinner_wrapper">
        <b-spinner medium />
      </div>
    </div>
    <div v-else class="monetise">
      <div style="flex:3">
        <Container
          width="middle"
          :bounds-inner-styles="{
            'padding-top': '3rem',
            'padding-bottom': '0rem'
          }"
          bounds-styles="padding-right: 15px; padding-left: 15px;"
        >
          <FormWizardStepHeader
            title="Pricing built for startup of all sizes"
            description="Tailored job posting options from pre-seed to post-IPO"
          />
        </Container>
        <!-- bounds-inner-styles="padding-top: 0rem; padding-bottom: 0rem;" -->
        <Container width="middle" bounds-styles="padding-right: 15px; padding-left: 15px;">
          <Plans
            :items="localizedCampaigns"
            :features="features"
            :parent-click-handler="onPlanClick"
            :pre-selected-plan-i-d="selectedPlanID"
            :show-highlighted-footer="false"
            :show-custom-button-title="true"
            :show-explore-link="true"
          />
        </Container>
        <LandingHero :hero="hero" :is-standalone="true" :width="width" />
        <Container
          background-color="#F5F7FA"
          bounds-styles="padding-right: 15px; padding-left: 15px;"
        >
          <h2 class="pb-40 pb-lg-80" style="text-align: center;">
            Why startups love us
          </h2>
          <h6 class="quotes-container-subtitle">Hear from our customers</h6>
          <LandingQuotesGrid :quotes="quotes" :is-embedded="!isStandalone" />
          <div class="pb-40 pb-60"></div>
        </Container>
        <Container
          background-color="#F5F7FA"
          style="margin-top: -10rem;"
          bounds-styles="padding-right: 15px; padding-left: 15px;"
        >
          <h2 class="pb-30 pb-lg-60 pt-40 pt-lg-80">
            Join 14,000+ Nordic startups hiring on the Hub
          </h2>
          <LandingClientsGrid :clients="clients" />
        </Container>
        <LandingHeroLight :hero="heroLight" :width="width" />
        <Container
          width="middle"
          class="faq_container"
          bounds-inner-styles="padding-top: 3rem; padding-bottom: 0px;"
          bounds-styles="padding-right: 15px; padding-left: 15px;"
        >
          <h2 style="margin-left: -0.15rem">
            Frequently
          </h2>
          <h2 style="margin-left: -0.15rem">
            asked questions
          </h2>
          <Container width="full" bounds-styles="padding-right: 15px; padding-left: 15px;">
            <Faq :faqs="faqs" />
          </Container>
        </Container>
      </div>
    </div>
  </div>
</template>
<script>
import Container from '@/components/Container';
import Faq from '@/components/Faq';
import FormWizardStepHeader from '@/components/FormWizardStepHeader';
import LandingQuotesGrid from '@/components/landing/LandingQuotesGrid';
import LandingClientsGrid from '@/components/landing/LandingClientsGrid';
import LandingHero from '@/components/landing/LandingHeroLite';
import LandingHeroLight from '@/components/landing/LandingHeroLightLite';
import { buildMetaHead } from '@/helpers/meta';
import Plans from '@/components/monetisation/Plans';
import { chatShow, chatHide } from '@/services/chatHelper.js';
import {
  compileLocalizedPlans,
  getFaqs,
  getFeatures
} from '@/components/monetisation/MonetisationUtils.js';

export default {
  name: 'JobMonetise',
  components: {
    Container,
    Faq,
    FormWizardStepHeader,
    LandingQuotesGrid,
    LandingClientsGrid,
    LandingHero,
    LandingHeroLight,
    Plans
  },
  props: {},
  head() {
    return buildMetaHead({
      title: 'Pricing for Startups of Any Size',
      description:
        'Three job posting options, pricing and features to meet your needs. Sign up on The Hub in 5 minutes and instantly post jobs to reach 400k+ talent.',
      path: this.$route.path,
      imageUrl: process.env.BASE_URL + '/images/pricing_meta.jpg'
      // script: [chatLoad({ user: this.user, isHidden: true })]
    });
  },
  data() {
    return {
      company: {},
      localizedCampaigns: [],
      isMounted: false,
      isLoaded: false,
      width: 0,
      isStandalone: false,
      monetisingOptions: [],
      hero: {
        title: 'Want a guaranteed hire?',
        subtitle:
          'Elevate your hiring game with a dedicated <b>Scout</b> equipped with access to The Hub’s 650k+ talent pool. No cure, no pay.',
        button: {
          link: '/scout',
          label: 'Explore Scout',
          isExternal: false
        },
        // caption: 'Takes less than ~2 min to complete',
        image: require('~/assets/components/funding/guy.png')
      },
      quotes: [
        {
          quote:
            '"The Hub is the first place we go to reach the Copenhagen tech and startup community"',
          person: {
            image: 'dk/ben.jpg',
            name: 'Ben Posseti',
            position: 'Head of Marketing',
            company: 'Donkey Republic'
          }
        },
        {
          quote:
            '"What we really enjoy with The Hub is that we can post any position and know we will get relevant applicants"',
          person: {
            image: 'lena.jpg',
            name: 'Lena Bachmeyer',
            position: 'Head of HR',
            company: 'Vultus'
          }
        },
        {
          quote: '"The Hub helped our recruiting tremendously!"',
          person: {
            image: 'fi/ilona.png',
            name: 'Ilona Mooney',
            position: 'Founder & CEO',
            company: 'WorkAhead'
          }
        }
      ],
      clients: [
        {
          image: 'startups/dk/wolt.png',
          url: '/startups/wolt-fi',
          name: 'Wolt'
        },
        { image: 'startups/dk/pleo.png', url: '/startups/pleo', name: 'Pleo' },
        {
          image: 'startups/se/karma.png',
          url: '/startups/karma',
          name: 'Karma'
        },
        {
          image: 'startups/no/kahoot.png',
          url: '/startups/kahoot',
          name: 'Kahoot'
        },
        {
          image: 'startups/dk/voi.png',
          url: '/startups/voi-technology',
          name: 'Voi'
        },
        {
          image: 'startups/se/truecaller.png',
          url: '/startups/truecaller',
          name: 'True caller'
        },
        {
          image: 'startups/fi/singa.png',
          url: '/startups/singa',
          name: 'Singa'
        },
        {
          image: 'startups/dk/templafy.png',
          url: '/startups/templafy',
          name: 'Templafy'
        },
        {
          image: 'startups/no/unacast.png',
          url: '/startups/unacast',
          name: 'Unacast'
        }
      ],
      faqs: getFaqs({ activeProducts: this.products }),
      features: getFeatures()
    };
  },
  computed: {
    products() {
      return this.$store.getters['meta/products'];
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn'];
    },
    user() {
      return this.$store.getters['user/data'];
    },
    userCurrentProfile() {
      return this.$store.getters['user/currentProfile'];
    },
    heroLight() {
      return {
        title: 'Hiring for multiple roles?',
        subtitle:
          'Contact sales and let us tailor the perfect recruitment bundle to meet your hiring needs.',
        button: {
          link: 'https://calendar.app.google/gt4PnvFUSPTg66JQ7',
          label: 'Book demo',
          isExternal: true
        },
        buttonSecondary: {
          link: !(this.isLoggedIn && this.userCurrentProfile?.type === 'company')
            ? '/client/startups/new'
            : `/client/startups/${this.company.key}/jobs/new`,
          label: 'Start hiring',
          newTab: true
        },
        // caption: 'Takes less than ~2 min to complete',
        image: require('~/assets/components/funding/new_guy.png')
      };
    },
    siteCountries() {
      return this.$store.getters['meta/siteCountries'];
    },
    sitePreferredCountryCode() {
      return this.$store.getters['meta/sitePreferredCountryCode'];
    }
  },
  async mounted() {
    this.startResizingObserver();
    chatShow({ user: this.user });

    await this.preInitialize({
      params: this.$route.params,
      axios: this.$axios
    });
    this.initialize();
  },
  beforeDestroy() {
    // chatDestroy()
    // alert('bb chat')
    chatHide();
  },
  methods: {
    onPlanClick(plan) {
      // console.log('onPlanClick', plan, this.userCurrentProfile);
      switch (plan.title) {
        case 'FREE':
          window.open(
            !(this.isLoggedIn && this.userCurrentProfile?.type === 'company')
              ? '/client/startups/new'
              : `/client/startups/${this.userCurrentProfile.key}/jobs/new`,
            '_blank'
          );
        case 'BASIC':
          window.open(
            !(this.isLoggedIn && this.userCurrentProfile?.type === 'company')
              ? '/client/startups/new'
              : `/client/startups/${this.userCurrentProfile.key}/jobs/new`,
            '_blank'
          );

        case 'PRO':
          window.open(
            !(this.isLoggedIn && this.userCurrentProfile?.type === 'company')
              ? '/client/startups/new'
              : `/client/startups/${this.userCurrentProfile.key}/jobs/new`,
            '_blank'
          );

        case 'MAX':
          window.open(
            !(this.isLoggedIn && this.userCurrentProfile?.type === 'company')
              ? '/client/startups/new'
              : `/client/startups/${this.userCurrentProfile.key}/jobs/new`,
            '_blank'
          );

        case 'HEADHUNTER':
          window.open(
            !(this.isLoggedIn && this.userCurrentProfile?.type === 'company')
              ? '/client/startups/new'
              : `/client/startups/${this.userCurrentProfile.key}/jobs/new`,
            '_blank'
          );

        default:
          return;
      }
    },
    startResizingObserver() {
      setTimeout(() => {
        this.onResize = () => {
          let mainContainerMonetise = this.$refs.mainContainerMonetise;
          this.width = mainContainerMonetise?.offsetWidth;
          this.$emit('resize', mainContainerMonetise?.offsetHeight);
        };
        this.ro = new ResizeObserver(this.onResize);
        let mainContainerMonetise = this.$refs.mainContainerMonetise;
        this.ro.observe(mainContainerMonetise);
        if (!this.isMounted) {
          this.isMounted = true;
        }
      }, 800);
    },
    preInitialize: async function({ axios }) {
      let { data: monetisingOptions } = await axios.get('/jobs/monetising-options');

      // console.log(
      //   'this.isLoggedIn && this.userCurrentProfile?.type === "company"',
      //   this.isLoggedIn && this.userCurrentProfile?.type === 'company'
      // );
      // console.log('this.userCurrentProfile', this.userCurrentProfile);
      // console.log('monetisingOptions', monetisingOptions);

      if (
        !this.isLoggedIn ||
        (this.userCurrentProfile && this.userCurrentProfile?.type !== 'company')
      ) {
        monetisingOptions = monetisingOptions.filter((option) => !option.isFree);
      }

      if (this.isLoggedIn && this.userCurrentProfile?.type === 'company') {
        if (
          this.userCurrentProfile.company &&
          this.userCurrentProfile.company.isFreeJobPostingAvailable
        ) {
          monetisingOptions = monetisingOptions.filter(
            (option) => option.name?.toUpperCase() !== 'BASIC'
          );
        } else {
          monetisingOptions = monetisingOptions.filter((option) => !option.isFree);
        }
      }

      this.monetisingOptions = monetisingOptions;
    },
    initialize: function() {
      try {
        this.company =
          this.userCurrentProfile?.type === 'company' ? this.userCurrentProfile.company : {};
        const companyCountryCode =
          this.company?.countries?.[0]?.countryCode || this.sitePreferredCountryCode || 'EU';

        // console.log('this.company', this.company);
        // console.log('this.siteCountries', this.siteCountries);
        // console.log('this.companyCountryCode', this.companyCountryCode);

        this.localizedCampaigns = compileLocalizedPlans({
          siteCountries: this.siteCountries,
          isJobRemote: true,
          companyCountryCode: companyCountryCode,
          isStandalone: this.isStandalone,
          allCampaigns: this.monetisingOptions,
          isLoggedIn: this.isLoggedIn,
          userCurrentProfile: this.userCurrentProfile,
          initCompany: this.company
        });

        this.isLoaded = true;
      } catch (err) {
        console.log('error', err);
        // error(err)
      }
    }
  }
};
</script>

<style scoped lang="scss">
.monetise-spinner_wrapper {
  width: 100%;
  height: calc(100vh - 10rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.quotes-container-subtitle {
  text-align: center;
  margin-bottom: 4rem;
  margin-top: -2rem;
  font-weight: 400;
}
.faq_container {
  // background-color: #f5f7fa;
}
</style>
